import { motion, AnimatePresence } from 'framer-motion'
import Swiper from 'swiper'
import { FC } from 'react'

import { TextContainer } from 'components/container'
import { containerVariants, variants } from './variants'
import {
  Description,
  NavTitle,
  Note,
  Navigation as StyledNavigation,
  Title,
} from './styled'

type Props = {
  swiper: React.MutableRefObject<Swiper | undefined>
  title?: string
  description?: string
  note?: string
  capitalizeDescription?: boolean
  titleInNav?: boolean
}

export const Navigation: FC<Props> = ({
  swiper,
  title,
  description,
  note,
  capitalizeDescription,
  titleInNav,
}) => (
  <TextContainer>
    <StyledNavigation>
      <button aria-label="Previous" onClick={() => swiper.current?.slidePrev()}>
        <svg
          width="31"
          height="32"
          viewBox="0 0 31 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.0718077 16.1396C12.3673 16.8646 23.5272 23.0407 30.8068 31.9179C30.928 32.102 31.034 31.9292 30.9847 31.8766L24.9127 16.0682L30.981 0.162134C30.981 0.162134 31.0074 -0.142163 30.7349 0.0832424C23.4552 8.89658 12.3181 15.2568 0.0718077 15.9931C0.0718077 15.9931 -0.000116072 16.0081 -0.000116067 16.0645C-0.000116062 16.1208 0.0718077 16.1358 0.0718077 16.1358L0.0718077 16.1396Z"
            fill="currentColor"
          />
        </svg>
      </button>

      {titleInNav && (
        <AnimatePresence mode="wait">
          <motion.div
            key={title}
            variants={containerVariants}
            initial="hidden"
            animate="enter"
            exit="leave"
          >
            <NavTitle
              variants={variants}
              $capitalize={capitalizeDescription}
              $noHyphens
            >
              {title}
            </NavTitle>
          </motion.div>
        </AnimatePresence>
      )}

      <button aria-label="Next" onClick={() => swiper.current?.slideNext()}>
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M31.924 15.8611C19.6285 15.1361 8.46868 8.95999 1.18903 0.0827903C1.06789 -0.10129 0.961898 0.07152 1.01111 0.124115L7.08316 15.9325L1.0149 31.8386C1.0149 31.8386 0.988397 32.1429 1.26096 31.9175C8.5406 23.1042 19.6777 16.744 31.924 16.0077C31.924 16.0077 31.996 15.9926 31.996 15.9363C31.996 15.8799 31.924 15.8649 31.924 15.8649V15.8611Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </StyledNavigation>

    <AnimatePresence mode="wait">
      <motion.div
        key={title}
        variants={containerVariants}
        initial="hidden"
        animate="enter"
        exit="leave"
      >
        {!titleInNav && (
          <Title variants={variants} $capitalize={capitalizeDescription}>
            {title}
          </Title>
        )}
        {!!description && (
          <Description variants={variants}>{description}</Description>
        )}
        {!!note && <Note variants={variants}>{note}</Note>}
      </motion.div>
    </AnimatePresence>
  </TextContainer>
)
